import { useState, FormEvent } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { PublicHeader } from "../components/Header";
import { Button } from "../components/Button";
import { Input } from "../components/Input";
import { ErrorBanner } from "../components/ErrorBanner";
import { login as apiLogin } from "../api/auth";
import { setParentJwt } from "../api/client";

export function LoginPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirectPath = params.get("redirect") || "/cabinet";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await apiLogin(email, password);
      setParentJwt(res.token);
      navigate(redirectPath);
    } catch (err: unknown) {
      const e = err as { response?: { data?: { detail?: string | unknown } } };
      const msg = e?.response?.data?.detail;
      setError(typeof msg === "string" ? msg : "Неверный email или пароль");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center p-6">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md bg-white p-8 border border-[var(--color-line)]"
        >
          <h1
            className="text-3xl mb-2"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            Вход в кабинет
          </h1>
          <p className="text-[var(--color-muted)] mb-6">Гордость 94</p>

          <ErrorBanner message={error} />

          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="email"
          />
          <Input
            label="Пароль"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />

          <Button
            type="submit"
            variant="primary"
            loading={loading}
            className="w-full"
          >
            Войти
          </Button>

          <div className="mt-4 text-center text-sm space-x-4">
            <Link to="/forgot" className="text-[var(--color-accent)]">
              Забыли пароль?
            </Link>
            <Link to="/register" className="text-[var(--color-accent)]">
              Регистрация
            </Link>
          </div>

          <p className="mt-6 pt-6 border-t border-[var(--color-line)] text-xs text-[var(--color-muted)] text-center">
            Для администрации — вход через{" "}
            <a
              href="https://teach.gim94.ru"
              className="underline"
            >
              teach.gim94.ru
            </a>
          </p>
        </form>
      </main>
    </div>
  );
}
